module.exports = __webpack_public_path__ + "1a3c263880436c26937f48c43a0db33e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/open-no-ss.png
// module id = 2922
// module chunks = 0